export default axios => ({
  index() {
    return axios.get('admin/permissions');
  },
  show(id) {
    return axios.get(`admin/permissions/${id}`);
  }
})
